module.exports = __webpack_public_path__ + "static/media/viber.294ac388.svg";